import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0a3c1156 = () => interopDefault(import('../pages/culture.vue' /* webpackChunkName: "pages/culture" */))
const _7b1ef715 = () => interopDefault(import('../pages/positions/index.vue' /* webpackChunkName: "pages/positions/index" */))
const _e335f112 = () => interopDefault(import('../pages/programs.vue' /* webpackChunkName: "pages/programs" */))
const _1305130c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _12b9babd = () => interopDefault(import('../pages/positions/_id.vue' /* webpackChunkName: "pages/positions/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/culture",
    component: _0a3c1156,
    pathToRegexpOptions: {"strict":true},
    name: "culture"
  }, {
    path: "/positions",
    component: _7b1ef715,
    pathToRegexpOptions: {"strict":true},
    name: "positions"
  }, {
    path: "/programs",
    component: _e335f112,
    pathToRegexpOptions: {"strict":true},
    name: "programs"
  }, {
    path: "/en/jobs",
    component: _1305130c,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/es/trabaja-con-nosotros",
    component: _1305130c,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/pt-br/trabalhe-conosco",
    component: _1305130c,
    pathToRegexpOptions: {"strict":true},
    name: "index___pt-br"
  }, {
    path: "/en/jobs/culture",
    component: _0a3c1156,
    pathToRegexpOptions: {"strict":true},
    name: "culture___en"
  }, {
    path: "/en/jobs/positions",
    component: _7b1ef715,
    pathToRegexpOptions: {"strict":true},
    name: "positions___en"
  }, {
    path: "/en/trabalhe-conosco/programas-de-carreira",
    component: _e335f112,
    pathToRegexpOptions: {"strict":true},
    name: "programs___en"
  }, {
    path: "/es/trabaja-con-nosotros/cultura",
    component: _0a3c1156,
    pathToRegexpOptions: {"strict":true},
    name: "culture___es"
  }, {
    path: "/es/trabaja-con-nosotros/ofertas",
    component: _7b1ef715,
    pathToRegexpOptions: {"strict":true},
    name: "positions___es"
  }, {
    path: "/es/trabalhe-conosco/programas-de-carreira",
    component: _e335f112,
    pathToRegexpOptions: {"strict":true},
    name: "programs___es"
  }, {
    path: "/pt-br/trabalhe-conosco/cultura",
    component: _0a3c1156,
    pathToRegexpOptions: {"strict":true},
    name: "culture___pt-br"
  }, {
    path: "/pt-br/trabalhe-conosco/programas-de-carreira",
    component: _e335f112,
    pathToRegexpOptions: {"strict":true},
    name: "programs___pt-br"
  }, {
    path: "/pt-br/trabalhe-conosco/vagas",
    component: _7b1ef715,
    pathToRegexpOptions: {"strict":true},
    name: "positions___pt-br"
  }, {
    path: "/",
    component: _1305130c,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/en/jobs/positions/:id",
    component: _12b9babd,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id___en"
  }, {
    path: "/es/trabaja-con-nosotros/ofertas/:id",
    component: _12b9babd,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id___es"
  }, {
    path: "/pt-br/trabalhe-conosco/vagas/:id",
    component: _12b9babd,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id___pt-br"
  }, {
    path: "/positions/:id",
    component: _12b9babd,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
